module.exports = "<footer class=\"footer\" style=\"margin-top: -1.6% !important;\">\n    <div class=\"container-fluid\">\n        <p class=\"copyright pull-right\">\n            &copy;\n            {{test | date: 'yyyy'}}\n            Created by <a href=\"https://krafti.com.br\" target=\"_blank\" style=\"color: #1d5f96\">Krafti</a>\n        </p>\n    </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = 569
// module chunks = 17